<template>

  <!--  ««« Сортировка и вид каталога-->
  <div class="container">
    <div class="view-settings">
      <Sort/>
      <ViewType/>
    </div>
  </div>
  <!--  Сортировка и вид каталога »»»-->

  <div class="page__section">
    <div class="container">
      <div class="pp-catalog">
        <div class="pp-catalog__body">
          <Item v-for="product in products" :key="product.id" v-bind:product="product"/>

          <Pagination/>
        </div>

        <!--Первая секция боковой колонки-->
        <div class="pp-catalog__aside aside aside_first">
          <SearchInGroup/>

          <div class="aside__block">
            <div class="price-notification">
              <div class="price-notification__heading">Цены — розничные!</div>
              <div class="price-notification__message">Скидки при оптовых поставках и комплектации объектов
                рассчитываем индивидуально.
              </div>
            </div>
          </div>

          <!--Фильтры и ссылки-->
          <GroupFiltersAndSubGroups/>
          <!--Фильтры и ссылки-->

        </div>
        <!-- Первая секция боковой колонки-->
      </div>
    </div>
  </div>


</template>

<script>
import Item from "./Item";
import Pagination from "./Pagination";
import Sort from "./Sort"
import ViewType from "./ViewType"
import SearchInGroup from "../SearchInGroup";
import GroupFiltersAndSubGroups from "../GroupFiltersAndSubGroups";
import {mapGetters} from 'vuex'

export default {
  name: "Products",
  components: {
    Item,
    Pagination,
    Sort,
    ViewType,
    SearchInGroup,
    GroupFiltersAndSubGroups
  },
  data() {
    return {}
  },
  updated() {
    window.scrollTo({
      top: 120,
      left: 0,
      behavior: 'smooth'
    });
  },
  computed: {
    // products() {
    //   return this.$store.getters['group_info/GET_PRODUCTS']
    // // },,
    ...mapGetters({
      products: 'group_info/GET_PRODUCTS',
    }),
  },

  methods: {},
}
</script>
